import React, {memo, useState} from 'react';

interface IconInterface {
    handler?: Function,
    classValue?: string,
    forwardRef?: React.RefObject<HTMLInputElement>
    clickedClassValue?: string
    content?: string,
    id?: string,
    disable?: boolean
    title?: string,
    hoverHandler?: Function
}

const IconComponent:React.FC<IconInterface> = ({
        handler,
        classValue,
        forwardRef,
        clickedClassValue,
        content,
        id,
        disable,
        title,
        hoverHandler
    }) => {

    const [active, setActive] = useState(false);

    const mouseDownHandler = () => {
        if (!active) setActive(true);
    };

    const mouseUpHandler = () => {
        if (active) setActive(false);
    };

    let classVal = active && clickedClassValue ? classValue + clickedClassValue : classValue;
    classVal = disable ? classVal + ' disable' : classVal;

    const handlerClick = (e: React.MouseEvent) => {
        if (disable) return;
        handler && handler(e);
    };

    const handlerHover = (e: React.MouseEvent) => {
        if (disable) return;
        hoverHandler && hoverHandler(e);
    };

    return (
        <div    onClick ={ handlerClick }
                onMouseEnter= { handlerHover }
                onMouseOut= { handlerHover }
                className={ classVal }
                ref={forwardRef}
                onMouseDown={ mouseDownHandler }
                onMouseUp={ mouseUpHandler }
                onMouseLeave={ mouseUpHandler }
                id={id}
                title={title}
        > { content && content }
        </div>
    )
};

export default memo(IconComponent)